import { Text } from "@hackthenorth/north";
import React from "react";
import styled from "styled-components";

import { useDeviceSize } from "src/shared/hooks/useDeviceSize";
import { PointsIcon } from "src/static/icons";
import { mediaQueries } from "src/theme/deviceBreakpoints";

interface Props {
  isComplete?: boolean;
  isAllTime?: boolean;
  points: number;
  completionLimit?: number;
}

export const BalanceChip = ({
  points,
  isComplete = false,
  isAllTime = false,
  completionLimit = 1,
}: Props) => {
  const isTabletOrSmaller = useDeviceSize("tablet");
  const isLargeMobileOrSmaller = useDeviceSize("largeMobile");

  return (
    <Outline isComplete={isComplete} isAllTime={isAllTime}>
      <PointsIcon size={isLargeMobileOrSmaller ? 18 : 24} variant="white" />
      <BucksText mods="p">
        {points + `${completionLimit > 1 && !isTabletOrSmaller ? " each" : ""}`}
      </BucksText>
    </Outline>
  );
};

const Outline = styled.div<{
  isComplete: boolean;
  isAllTime?: boolean;
}>`
  background: ${({ theme, isComplete, isAllTime }) =>
    isComplete
      ? theme.globalConstants.color.backgroundGrayDark
      : isAllTime
      ? theme.globalConstants.color.bluePrimary1
      : theme.globalConstants.color.backgroundPrimary};
  color: ${({ theme }) => theme.globalConstants.color.white};
  display: flex;
  padding: 4px 9.189px;
  align-items: center;
  gap: 4px;
  border-radius: 32px;
  height: 32px;
`;

const BucksText = styled(Text)`
  color: white !important;
  white-space: nowrap;

  ${mediaQueries.largeMobile} {
    font-size: 14px !important;
  }
`;
